/**
 * Kural setindeki sayfa kapsami ve takma adlari.
 *
 * - Takma ad (alias): { match: "^/urun/\\d+$", as: "/urun/:id" } — event'e page.pattern olarak yazilir,
 *   boylece raporlarda binlerce ayri URL yerine tek satir gorunur.
 * - Kural kapsami (rule.paths): takma ad ismi veya basit glob (* ve ?).
 */

const MAX_ALIASES = 100;

/** Basit glob'u regex'e cevirir: /urun/* -> ^/urun/.*$ */
function globToRegExp(pattern) {
    const escaped = pattern
        .replace(/[.+^${}()|[\]\\]/g, "\\$&")
        .replace(/\*/g, ".*")
        .replace(/\?/g, ".");
    try {
        return new RegExp("^" + escaped + "$");
    } catch (e) {
        return null;
    }
}

class PathMatcher {
    constructor() {
        this.aliases = [];
        this.globCache = {};
    }

    /** @param {Array} aliases [{ match, as }] */
    configure(aliases) {
        this.aliases = [];
        this.globCache = {};
        const list = Array.isArray(aliases) ? aliases.slice(0, MAX_ALIASES) : [];
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (!item || !item.match || !item.as) continue;
            try {
                this.aliases.push({ regexp: new RegExp(item.match), as: String(item.as) });
            } catch (e) {
                /* gecersiz regex sessizce atlanir */
            }
        }
    }

    /**
     * Gecerli yolun takma adi.
     * @returns {String} eslesme yoksa bos string
     */
    resolvePattern(path) {
        const target = path || window.location.pathname;
        for (let i = 0; i < this.aliases.length; i++) {
            if (this.aliases[i].regexp.test(target)) return this.aliases[i].as;
        }
        return "";
    }

    /**
     * Kural bu sayfada calisir mi.
     * @param {Array} paths rule.paths (bos = tum sayfalar)
     */
    matches(paths, path) {
        if (!Array.isArray(paths) || paths.length === 0) return true;
        const target = path || window.location.pathname;
        const pattern = this.resolvePattern(target);

        for (let i = 0; i < paths.length; i++) {
            const entry = paths[i];
            if (!entry) continue;
            // Takma ad ismi verildiyse alias regex'i ile karsilastirilir
            if (pattern && entry === pattern) return true;
            const regexp = this.getGlob(entry);
            if (regexp && regexp.test(target)) return true;
        }
        return false;
    }

    getGlob(pattern) {
        if (this.globCache[pattern] === undefined) {
            this.globCache[pattern] = globToRegExp(pattern);
        }
        return this.globCache[pattern];
    }
}

export const pathMatcher = new PathMatcher();
export default pathMatcher;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/rules/paths.js
// module id = 24Rx
// module chunks = 1 2